<template>
  <c-view v-min-height>
    <c-page>
      <c-content>
        <div class="alpha-register">
          <div class="header bg-img">
          </div>
          <div class="content">
            <div class="register-form">
              <form action="">
                <div class="s-form-group">
                  <i class="s-icon s-icon-telephone prepend-icon"></i>
                  <input type="phone"
                         ref="J_phone"
                         @blur="handlerBlurPhone"
                         v-model.trim="formData.account"
                         class="prepend-icon"
                         placeholder="请输入手机号码">
                </div>
                <div class="s-form-group">
                  <i class="s-icon s-icon-password prepend-icon"></i>
                  <input type="password"
                         ref="J_pwd"
                         @blur="resetScroll"
                         v-model.trim="formData.password"
                         class="prepend-icon"
                         placeholder="请输入密码">
                </div>
                <div class="s-form-group">
                  <i class="s-icon s-icon-password prepend-icon"></i>
                  <input type="text"
                         ref="J_code"
                         @blur="resetScroll"
                         v-model.trim="formData.verifycode"
                         style="width: 60%"
                         class="prepend-icon"
                         placeholder="请输入验证码">
                  <div class="code__box">
                    <img v-if="formData.flowId"
                         @click="initCodePath"
                         :src="codeImgPath"
                         alt="">
                  </div>
                </div>
              </form>
            </div>
            <div class="s-btn s-btn--orange"
                 @click="nextStep()">免费注册开通</div>
            <p class="mt-20 text-center text-color gray">
              点击免费注册开通，即同意
              <a @click="goUserTerm()"
                 class="text-color orange">《生意专家用户协议》</a>
            </p>
          </div>
          <div class="footer-container">
            <info-footer></info-footer>
          </div>
        </div>
      </c-content>
    </c-page>
    <router-view></router-view>
  </c-view>
</template>
<script>
import InfoFooter from '../info-footer'
import RegisterModel from '../../model/agent-register-user/index'
import debounce from 'lodash.debounce'
export default {
  name: 'NewAgentRegisterUser',
  data () {
    return {
      registerModel: new RegisterModel(),
      formData: {
        account: null,
        password: null,
        storename: '店铺名称未设置',
        verifycode: null,
        type: 1,
        flag: 12,
        recommend: null,
        mobileweb: 'on',
        regagentflag: null,
        flowId: null
      }
    }
  },
  components: { InfoFooter },
  mounted () {
    // 从router获取代理商参数
    this.formData.regagentflag = this.$route.query.regagentflag ? this.$route.query.regagentflag : null
    this.formData.recommend = this.$route.query.recommend ? this.$route.query.recommend : null
    this.initCodePath()
  },
  methods: {
    /**
     * 输入完成手机号之后进行检测此手机号是否已经注册过
     */
    async handlerBlurPhone () {
      this.resetScroll()
      if (this._checkPhone()) {
        let json = await this.registerModel.checkUserStatus(this.formData.account)
        if (json.data === 1) { // 已存在，已激活
          this.$wejs.alert('此手机号已经注册过了！')
          this.$refs.J_phone.select()
        } else if (json.data === 3) { // 已存在，未激活
          let jsonData = await this.registerModel.resendCode(this.formData.account)
          if (Number.parseInt(jsonData) === 1) {
            this.$router.push({ path: `/newagent-register-activation/${this.formData.account}` })
          }
        }
      }
    },
    /**
     * 用户协议
     */
    goUserTerm () {
      this.$router.push({ path: '/sign-up/user-term' })
    },
    /**
     * 初始化验证码地址
     */
    initCodePath () {
      this.registerModel.getCreateReg().then(json => {
        this.formData.flowId = json.data
      })
    },
    // 下一步
    nextStep: debounce(async function () {
      if (this._checkParams()) {
        let loadingInstance = this.$wejs.loading('数据提交中')
        let result = await this.registerModel.registerUser(this.formData)
        if (result.data === '1001') { // 验证码输入有误
          loadingInstance.hide()
          this.$wejs.alert('您输入的验证码有误，请重新输入', () => {
            this.initCodePath()
            this.$refs.J_code.select()
          })
        } else if (result.data === '1003') { // 店铺名称有误
          loadingInstance.hide()
          this.$wejs.alert('您输入的店铺名称有误，请重新输入', () => {
            this.initCodePath()
            this.$refs.J_code.select()
          })
        } else if (result.data === '0000') { // 验证通过，跳转
          loadingInstance.hide()
          this.$router.push({
            path: `/agent-register-activation`,
            query: {
              phone: this.formData.account,
              flowId: this.formData.flowId
            }
          })
        }
      }
    }, 300),
    /**
     * 检测参数是否合法
     * @private
     * @return {boolean} 检测结果
     */
    _checkParams () {
      // 验证参数
      // if (!this.formData.storename) {
      //   this.$wejs.alert('请输入店铺名称', () => {
      //     this.$refs.J_shopName.focus()
      //   })
      //   return false
      // } else
      //   if (this.formData.storename.length > 8 || this.formData.storename.length < 2) {
      //     this.$wejs.alert('店铺名称支持2到8位', () => {
      //       this.$refs.J_shopName.focus()
      //     })
      //     return false
      //   }
      if (!this.formData.account) {
        this.$wejs.alert('请输入手机号码', () => {
          this.$refs.J_phone.focus()
        })
        return false
      } else if (!(/^((1)+\d{10})$/.test(this.formData.account))) {
        this.$wejs.alert('请输入正确的手机号码', () => {
          this.$refs.J_phone.focus()
        })
        return false
      } else if (!this.formData.password) {
        this.$wejs.alert('请输入密码', () => {
          this.$refs.J_pwd.focus()
        })
        return false
      } else if (!(/^[a-z0-9]{6,12}$/.test(this.formData.password))) {
        this.$wejs.alert('请输入6-12位数字或字母密码', () => {
          this.$refs.J_pwd.focus()
        })
        return false
      } else if (!this.formData.verifycode) {
        this.$wejs.alert('请输入验证码', () => {
          this.$refs.J_code.focus()
        })
        return false
      } else if (this.formData.verifycode.length !== 4) {
        this.$wejs.alert('请合法的验证码', () => {
          this.$refs.J_code.focus()
        })
        return false
      } else {
        return true
      }
    },
    /**
     * 检测手机号是否合法，服务于发送验证码
     * @return {boolean}
     * @private
     */
    _checkPhone () {
      if (!this.formData.account) {
        return false
      } else if (!(/^((1)+\d{10})$/.test(this.formData.account))) {
        return false
      } else {
        return true
      }
    },
    // ios 兼容，input失去焦点后界面上移不恢复的问题
    resetScroll () {
      setTimeout(() => {
        let scrollHeight = document.documentElement.scrollTop || document.body.scrollTop || 0
        window.scrollTo(0, Math.max(scrollHeight - 1, 0))
      }, 100)
    }
  },
  computed: {
    codeImgPath () {
      if (this.formData.flowId) {
        return `http://webapi.i200.cn/v0/albert/security/verify-codeFlowId?flowId=${this.formData.flowId}`
      }
      return null
    }
  }
}
</script>
<style lang="scss" scoped>
@import './index';
</style>



// WEBPACK FOOTER //
// index.vue?129ab95a